import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default RouteTemplate(class HelpPageTemplate extends Component {
  <template>
    {{pageTitle "Help"}}
    {{pageTitle @model.helpPage.title}}

    <h3 class="c-page-title qa-page-title">{{@model.helpPage.title}}</h3>
    <div class="c-html-content">
      {{~trustedHtml @model.helpPage.bodyProcessed~}}
    </div>

    {{outlet}}
  </template>
});
